import chroma from 'chroma-js';
import {css, getSimilarColor} from '../utils.js';

const styles = css`
    /* Card Header CSS */

    .ddk-container .ddk-card .ddk-card-header {
        display: flex;
        flex-flow: wrap;
        width: auto;
        padding: var(--ddk-padding-sm, 16px) var(--ddk-padding-sm, 16px);
        align-items: center;
        gap: var(--ddk-spacing-space-2, 16px);
        background: ${props =>
            props.theme.card_header_background_color ??
            'var(--ddk-surface-surface-secondary)'};
        border-bottom-width: 1px;
        border-bottom-style: ${props =>
            props.theme.card_header_border.style ?? 'solid'};
        border-bottom-color: ${props =>
            props.theme.card_header_accent ??
            'var(--ddk-border-base-secondary)'};
        border-top-right-radius: ${props =>
            props.theme.card_header_border.radius ?? '0px'};
        border-top-left-radius: ${props =>
            props.theme.card_header_border.radius ?? '0px'};
        box-shadow: ${props => props.theme.card_header_box_shadow};
    }

    .ddk-container .ddk-card-header .ddk-card-description {
        color: ${props =>
            props.theme.card_description_text ??
            'var(--ddk-text-base-secondary)'};
        font-family: ${props => props.theme.font_family};
        font-size: ${props =>
            props.theme.card_description_font_size ??
            'var(--ddk-font-size-md)'};
        font-style: normal;
        font-weight: var(--ddk-font-semi-light);
        line-height: 150%; /* 24px */
        letter-spacing: 0.08px;
    }

    .ddk-card-header .card-header-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex: 1 0 0;
    }

    .ddk-card-header .card-header-title {
        display: flex;
        align-items: center;
        gap: var(--ddk-grid-1);
        flex: 1 0 0;
    }

    .ddk-card-header .card-header-title-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        color: ${props =>
            props.theme.card_title_text ?? 'var(--ddk-text-text-primary)'};
        font-family: ${props => props.theme.font_family};
        font-size: ${props => props.theme.card_title_font_size ?? '20px'};
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 30px */
        letter-spacing: 0.03px;
    }

    /* Card Description Icon and Drawer CSS */

    .ddk-card-header .card-description-icon,
    .ddk-card-header .card-description-icon svg {
        border: none;
        background: none;
        padding: var(--ddk-padding-none);
        width: 24px;
        height: 24px;
        color: ${props => props.theme.accent};
    }

    .ddk-card-header .card-description-icon svg:hover {
        cursor: pointer;
    }

    .ddk-card-header .card-header-buttons {
        display: flex;
        align-items: center;
    }

    .ddk-container .ddk-card .card-description-drawer {
        position: absolute;
        width: 0px;
        z-index: 2;
        top: 0;
        left: 0;
        overflow-x: hidden;
        transition: 0.3s ease;
    }

    .ddk-container .ddk-card .card-description-drawer.open {
        border-right-width: 1px;
        border-right-style: ${props =>
            props.theme.card_header_border.style ?? 'solid'};
        border-right-color: ${props =>
            props.theme.card_header_accent ??
            'var(--ddk-border-base-secondary)'};
        border-right-radius: var(--ddk-radius-none);
    }

    .ddk-container .ddk-card .card-description-content {
        display: block;
        height: auto;
        padding: var(--ddk-grid-2, 16px);
        background: ${props =>
            props.theme.card_description_background_color ??
            'var(--ddk-surface-base-surface-1, #FFF)'};
    }

    .ddk-container .ddk-card .card-description-drawer::-webkit-scrollbar {
        background-color: var(--ddk-surface-base-surface-1, #FFF);
    }

    /* Card Menu CSS */

    .card-menu {
        display: inline-flex;
        padding: var(--ddk-grid-2, 16px);
        flex-direction: column;
        align-items: flex-start;
        gap: var(--ddk-grid-2, 16px);
        background: ${props =>
            props.theme.card_menu_background_color ??
            'var(--ddk-surface-base-surface-1, #FFF)'};
    }

    .card-menu .card-menu-item-wrapper {
        width: 100%;
    }

    .card-menu .card-menu-item {
        display: flex;
        padding: var(--ddk-grid-half, 4px) var(--ddk-grid-1, 8px);
        width: 100%;
        align-items: flex-start;
        gap: 10px;
        align-self: stretch;
        color: ${props =>
            props.theme.card_menu_text ??
            'var(--ddk-text-base-primary, #101010)'};
        font-family: ${props => props.theme.font_family};
        font-size: var(--ddk-font-size-md));
        font-style: normal;
        font-weight: var(--ddk-font-semi-light);
        line-height: 150%; /* 24px */
        letter-spacing: 0.024px;
        text-transform: capitalize;
        transition: all 0.3s ease;
    }

    .card-menu .card-menu-item:hover {
        cursor: pointer;
        background: ${props =>
            getSimilarColor(
                chroma.valid(props.theme.card_menu_background_color)
                    ? props.theme.card_menu_background_color
                    : '#FFF',
                'darken',
                10
            )};
    }

    .ddk-card-header .tippy-content {
        padding: var(--ddk-padding-none);
    }

    .card-menu .expandToFull, .card-menu .copyText {
        padding: var(--ddk-padding-none);
    }
`;

export default styles;
